import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-21">
        <div className="flex items-center gap-3" data-id="element-22">
          <img src="https://cdn.prod.website-files.com/67475a38f606df632637a769/674e51ca7e86ce039e92cab1_Lighthouse-Logomark-p-500.png" alt="Lighthouse HRAI Consulting Logo" className="h-10 w-10 object-contain" data-id="element-23" />
          <span className="text-xl font-bold text-slate-900" data-id="element-24">
            Lighthouse HRAI Consulting
          </span>
        </div>
      </div>
    </motion.header>;
}